import OlMap from 'ol/Map'

import { OverviewMap } from 'ol/control'
import TileLayer from 'ol/layer/Tile'
import XYZ from 'ol/source/XYZ'
import { createXYZ } from 'ol/tilegrid'

import { authenticatedRasterTileLoadFunction } from '../../atoms/map/utils/authenticatedRasterTileLoadFunction'
import { changeMapTiles } from '../../atoms/map/utils/changeMapTiles'
import { getTileUrl } from '../../atoms/map/utils/tiles'

import { MapControlsTexts } from './texts'

const normalTileUrl = getTileUrl({ tileType: 'normal' })

export function registerOverviewMapControl(
  map: OlMap,
  tile: uui.domain.ui.map.MapTile,
  texts: MapControlsTexts,
) {
  const uniqueId = 'rm-overview-map'
  const controls = map.getControls()

  if (controls.get(uniqueId)) return

  const tileLayerSource = new XYZ({
    url: getTileUrl({
      tileType: tile === 'normal' ? 'hybrid' : 'normal',
    }),
    tileLoadFunction: authenticatedRasterTileLoadFunction,
    tileGrid: createXYZ({
      // extent: Base_bounds,
      minZoom: 3,
      maxZoom: 42,
      tileSize: 64,
    }),
    crossOrigin: 'Anonymous',
  })

  const tileLayer = new TileLayer({
    preload: 0, // Infinity,
    source: tileLayerSource,
  })

  const overviewMapControl = new OverviewMap({
    layers: [tileLayer],
    className: 'ol-overviewmap ol-custom-overviewmap',
    collapsed: false,
    collapsible: false,
  })

  const overviewMapInstance = overviewMapControl.getOverviewMap()

  overviewMapInstance.on('click', _e => {
    // Update the tile type for the main map
    const tileType = tileLayerSource.getUrls()?.[0] === normalTileUrl ? 'normal' : 'hybrid'

    // Update the tile type for the main map
    changeMapTiles(tileType)

    // Update the tooltip
    const overviewMapElement = overviewMapControl.getOverviewMap().getViewport()
      .firstChild as HTMLElement

    overviewMapElement.setAttribute(
      'title',
      tileType === 'hybrid' ? texts.switchToMap : texts.switchToSatellite,
    )
  })

  // Set the tooltip
  setTimeout(() => {
    const overviewMapElement = overviewMapControl.getOverviewMap().getViewport()
      .firstChild as HTMLElement

    overviewMapElement.setAttribute(
      'title',
      tile === 'hybrid' ? texts.switchToMap : texts.switchToSatellite,
    )

    overviewMapElement.setAttribute('data-testid', 'main-map-control-switch-map-tiles-style-button')
    overviewMapElement.setAttribute(
      'data-trackid',
      'main-map-control-switch-map-tiles-style-button',
    )
  }, 300)

  // Set the unique id
  overviewMapControl.set('uid', uniqueId)

  // Add the control to the map
  map.addControl(overviewMapControl)

  // Add the control to the controls map
  controls.set(uniqueId, overviewMapControl)
}
